import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Order } from '../../../../orders/models/order.models';
import { PhoneValidator } from '../../../../shared/validators/phone.validator';

@Component({
  selector: 'app-customer-info-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './customer-info-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class CustomerInfoTabComponent {
  @Input() order: Order | null = null;

  formatPhoneNumber(phone: string | null | undefined): string {
    return PhoneValidator.formatUsaPhone(phone);
  }
}
